import { Autocomplete } from '@flixbus/honeycomb-react';

import CrewMemberSearchOption from './CrewMemberSearchOption';
import { CREW_MEMBER_SEARCH_TEXT } from './text';
import { useCrewMemberSearch } from './useCrewMemberSearch';

import styles from './styles.module.css';

const CrewMemberSearch = ({ disabled, setValue, driverName, setDriverName }) => {
	const { isSearching, crewMembers, onDebounce, onSelect, onChange } = useCrewMemberSearch({
		setValue,
		setDriverName,
	});

	return (
		<div className={styles.crewMemberSearch}>
			<Autocomplete
				options={crewMembers}
				inputValue={driverName}
				onDebounce={onDebounce}
				onChange={onSelect}
				comboboxProps={{
					type: 'search',
					autoComplete: 'off',
					label: CREW_MEMBER_SEARCH_TEXT.searchLabel,
					placeholder: CREW_MEMBER_SEARCH_TEXT.searchPlaceholder,
					loading: isSearching,
					disabled,
					toggleProps: {
						label: CREW_MEMBER_SEARCH_TEXT.toggleLabel,
						disabled: !crewMembers.length,
					},
					onChange,
				}}
				listBoxProps={{
					'aria-label': CREW_MEMBER_SEARCH_TEXT.resultsAriaLabel,
					appearance: 'boxed',
					highlightOptions: 'both',
					optionsToDisplay: 5,
					renderGroupName: ({ group }) => <span className={styles.groupHeader}>{group}</span>,
					optionProps: (option) => ({
						renderOption: () => <CrewMemberSearchOption option={option} />,
					}),
				}}
			/>
		</div>
	);
};

export default CrewMemberSearch;
